import { render, staticRenderFns } from "./Txs.vue?vue&type=template&id=220b6e3f&scoped=true&"
import script from "./Txs.vue?vue&type=script&lang=js&"
export * from "./Txs.vue?vue&type=script&lang=js&"
import style0 from "./Txs.vue?vue&type=style&index=0&id=220b6e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b6e3f",
  null
  
)

export default component.exports